import React from "react";

const MyStoreIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.5003 8.01004L21.0003 3.51004C20.9481 3.35481 20.8465 3.22092 20.7111 3.12883C20.5757 3.03674 20.4138 2.99151 20.2503 3.00004H3.75029C3.58674 2.99151 3.42489 3.03674 3.28947 3.12883C3.15404 3.22092 3.05248 3.35481 3.00029 3.51004L1.50029 8.01004C1.48949 8.08968 1.48949 8.17041 1.50029 8.25004V12.75C1.50029 12.949 1.57931 13.1397 1.71996 13.2804C1.86061 13.421 2.05138 13.5 2.25029 13.5H3.00029V21H4.50029V13.5H9.00029V21H21.0003V13.5H21.7503C21.9492 13.5 22.14 13.421 22.2806 13.2804C22.4213 13.1397 22.5003 12.949 22.5003 12.75V8.25004C22.5111 8.17041 22.5111 8.08968 22.5003 8.01004ZM19.5003 19.5H10.5003V13.5H19.5003V19.5ZM21.0003 12H18.0003V9.00004H16.5003V12H12.7503V9.00004H11.2503V12H7.50029V9.00004H6.00029V12H3.00029V8.37004L4.29029 4.50004H19.7103L21.0003 8.37004V12Z"
      fill="#9CA3AF"
    />
  </svg>
);

export default MyStoreIcon;
